import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useTranslation } from '../../../../i18n/translate/useTranslation';
import { useFormatOnChange } from '../../../../form/useFormatOnChange';
import { useDetailsFormContext } from '../../hooks/useDetailsFormContext';
import { formatInternationalPhoneNumber } from '../../helpers/formatInternationalPhoneNumber';

export const PhoneNumber = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	const formatOnChange = useFormatOnChange(
		'phoneNumber',
		formatInternationalPhoneNumber,
	);

	return (
		<TextField
			label={t('parking_details_form_phone_number_label')}
			placeholder={t('parking_details_form_phone_number_placeholder')}
			invalid={!!errors.phoneNumber}
			error={errors.phoneNumber?.message}
			{...props}
			{...register('phoneNumber', {
				onChange: (e) => {
					formatOnChange(e);
				},
			})}
		/>
	);
};
